module.exports = __webpack_public_path__ + "img/step3.4b2ff632.png";